import { FormControl, TextField as MaterialTextField, FormLabel } from "@mui/material";
import { TextAreaProps } from ".";

const TextArea = ({ label, fullWidth, readOnly, required, ...props }: TextAreaProps) => {
  return (
    <FormControl disabled={props.disabled} fullWidth={fullWidth} required={required}>
      {label && <FormLabel>{label}</FormLabel>}
      <MaterialTextField multiline InputProps={{ readOnly }} {...props} />
    </FormControl>
  );
};

export default TextArea;
